import React from 'react';
import { Container, Row, Col, Card } from 'react-bootstrap';
import { motion } from 'framer-motion';
import { FaArrowRight, FaGraduationCap, FaHandshake, FaGlobe } from 'react-icons/fa';
import { useTranslation } from 'react-i18next';
import './Alumni.css';

const Alumni = () => {
  const { t } = useTranslation();

  return (
    <div className="news-page bg-light-subtle">
      <section className="news-hero py-5">
        <Container>
          <Row className="" style={{ color: '#006186'}}>
            <Col lg={9}>
                <h1 className="display-4 fw-bold  mb-3 ">
                  {t('alumni_title', 'Выпускникам')} 
                </h1>
                <div className="header-line mb-4"></div>

            </Col>
          </Row>
        </Container>
      </section>

      <Container className="py-5">
        {/* ОСНОВНОЙ ТЕКСТОВЫЙ БЛОК */}
        <Row className="mb-5 g-4">
          <Col lg={8}>
            <div className="bg-white p-4 p-md-5 rounded-4 shadow-sm border">
              <h3 className="fw-bold mb-4 text-dark">Миссия Ассоциации</h3>
              <p className="fs-5 text-muted mb-4">
                Мы помогаем выпускникам и Университету найти общие интересы, будь то научный проект, получение дополнительного образования или формирование экспертного сообщества. Наша цель — объединить опыт профессионалов для развития экономики и будущего наших студентов.
              </p>
              
              <h5 className="fw-bold mb-3 text-primary">Что мы предлагаем сегодня:</h5>
              <div className="alumni-text-list">
                <div className="list-item d-flex mb-3">
                  <FaArrowRight className="text-primary mt-1 me-3 flex-shrink-0" />
                  <p className="mb-0">Единая информационная среда для общения выпускников разных лет и специальностей по всему миру.</p>
                </div>
                <div className="list-item d-flex mb-3">
                  <FaArrowRight className="text-primary mt-1 me-3 flex-shrink-0" />
                  <p className="mb-0">Регулярные встречи, мастер-классы и лектории от успешных выпускников для нынешнего поколения студентов.</p>
                </div>
                <div className="list-item d-flex mb-3">
                  <FaArrowRight className="text-primary mt-1 me-3 flex-shrink-0" />
                  <p className="mb-0">Поддержка стартапов и инновационных проектов через экспертное сообщество ассоциации.</p>
                </div>
              </div>
            </div>
          </Col>

          {/* БОКОВАЯ КОЛОНКА (SIDEBAR) */}
          <Col lg={4}>
            <div className="h-100 d-flex flex-column gap-4">
              <Card className="news-card border-0 shadow-sm bg-primary text-white p-3">
                <Card.Body>
                  <FaGraduationCap size={40} className="mb-3 opacity-75" />
                  <h5 className="fw-bold">Вступай в клуб</h5>
                  <p className="small mb-0">Стань частью официального Alumni Club ОшТУ и получи доступ к закрытым мероприятиям.</p>
                </Card.Body>
              </Card>

              <Card className="news-card border-0 shadow-sm p-3">
                <Card.Body>
                  <FaHandshake size={40} className="mb-3 text-primary opacity-75" />
                  <h5 className="fw-bold text-dark">Партнерство</h5>
                  <p className="small text-muted mb-0">Предложи свой проект или стань ментором для талантливых студентов своего факультета.</p>
                </Card.Body>
              </Card>
            </div>
          </Col>
        </Row>

        {/* НИЖНИЙ БЛОК С ВОЗМОЖНОСТЯМИ — Сетка как в О нас */}
        <div className="py-5">
          <h3 className="fw-bold mb-5 text-center">Цифровые возможности сообщества</h3>
          <Row className="g-4">
            {[
              { icon: <FaGlobe />, text: "Веб-портал выпускников с поиском коллег" },
              { icon: <FaHandshake />, text: "Региональные представительства и клубы" },
              { icon: <FaArrowRight />, text: "Новостные рассылки и экспертные дайджесты" },
              { icon: <FaCheckCircle />, text: "Официальная сувенирная продукция" }
            ].map((item, i) => (
              <Col md={6} lg={3} key={i}>
                <div className="text-center p-4 h-100 bg-white border rounded-4 shadow-sm hover-up">
                  <div className="fs-2 text-primary mb-3">{item.icon}</div>
                  <p className="fw-bold text-dark small mb-0">{item.text}</p>
                </div>
              </Col>
            ))}
          </Row>
        </div>
      </Container>
    </div>
  );
};

// Дополнительная иконка для списка
const FaCheckCircle = () => (
  <svg stroke="currentColor" fill="currentColor" strokeWidth="0" viewBox="0 0 512 512" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg">
    <path d="M256 8C119.033 8 8 119.033 8 256s111.033 248 248 248 248-111.033 248-248S392.967 8 256 8zm0 464c-118.664 0-216-96.055-216-216 0-118.663 96.055-216 216-216 118.664 0 216 96.055 216 216 0 118.663-96.055 216-216 216zm141.63-274.961L217.15 376.071c-4.705 4.667-12.303 4.637-16.97-.068l-85.878-86.572c-4.667-4.705-4.637-12.303.068-16.97l22.719-22.536c4.705-4.667 12.303-4.637 16.97.068l54.589 55.031L351.684 148.63c4.705-4.667 12.303-4.637 16.97.068l24.615 24.417c4.667 4.705 4.637 12.303-.068 16.97z"></path>
  </svg>
);

export default Alumni;